import React from 'react';
import { SEAT_LABELS } from '../utils/tableSeats';

function formatVacancyList(seats) {
  return (seats || [])
    .map((e) => `${e.username || 'Player'} (${SEAT_LABELS[e.seat] || e.seat})`)
    .join(', ');
}

function TableVacancyPrompt({
  prompt,
  onFillBots,
  onWaitForPlayer,
  floating = false,
}) {
  const seats = prompt?.seats;
  if (!seats?.length) return null;

  const panelClass = [
    'spades-bid-panel',
    'spades-vacancy-panel',
    floating ? 'spades-bid-panel--float' : '',
  ].filter(Boolean).join(' ');

  const detail = seats.length === 1
    ? `${seats[0].username || 'A player'} left ${SEAT_LABELS[seats[0].seat] || seats[0].seat}.`
    : `Open seats: ${formatVacancyList(seats)}.`;

  return (
    <div className={panelClass} role="dialog" aria-label="Vacant seat">
      <p className="spades-bid-prompt">Seat open</p>
      <p className="spades-vacancy-detail">{detail}</p>
      <div className="spades-vacancy-actions">
        <button
          type="button"
          className="spades-bid-btn spades-bid-btn--primary spades-host-btn--wide"
          onClick={onFillBots}
        >
          Replace with bot
        </button>
        <button
          type="button"
          className="spades-bid-btn spades-host-btn--toggle"
          onClick={onWaitForPlayer}
        >
          Wait for player
        </button>
      </div>
    </div>
  );
}

export default TableVacancyPrompt;